import { Component, ViewChild } from '@angular/core';
import { ApiClientService } from '../../services/api-client.service';

@Component({
  selector: 'app-produzeci-saradnje',
  templateUrl: './produzeci-saradnje.component.html',
  styleUrls: ['./produzeci-saradnje.component.scss']
})
export class ProduzeciSaradnjeComponent {
  @ViewChild('produzeciGrid', { static: false }) produzeciGrid: any;

  gridData: any[] = [];
  loading = false;
  loadPanelPosition = { of: '#produzeciGrid' };

  constructor(private apiClient: ApiClientService) { }

  ngOnInit() {
    this.loadProduzeciSaradnje();
  }

  async loadProduzeciSaradnje() {
    this.loading = true;
    try {
      const response = await this.apiClient.istek();

      // Convert the object to array for the grid
      this.gridData = Object.keys(response).map(key => ({
        naziv: key,
        datum: new Date(response[key])
      }));

      // Sort by date (most recent first)
      this.gridData.sort((a, b) => b.datum.getTime() - a.datum.getTime());

    } catch (error) {
      console.error('Error loading produzeci saradnje:', error);
    } finally {
      this.loading = false;
    }
  }

  onRefreshClick() {
    this.loadProduzeciSaradnje();
  }
}
